// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"_1xPLHgmP0jXJB-PhmFxfGP","Question":"_2AtZSBFDkKnb10wuiQdXSm"};